import {
  createIncomeOrExpenseAddRoute,
  LP_CAPITAL_ACTION_CREATE,
} from 'adminConstants/routes';
import SuccessPage from 'components/new/SuccessPage';
import { IncomeOrExpenseType } from 'further-types/lp/income-and-expenses';
import { useParams } from 'react-router-dom';

const Success: React.FC = () => {
  const { type } = useParams<{ type?: IncomeOrExpenseType }>();

  const label = type === IncomeOrExpenseType.Income ? 'Income' : 'Expense';

  const content =
    type === IncomeOrExpenseType.Income ? (
      <>
        The <i>General ledger</i> has been updated and this income will be
        available for distribution in the next capital action.
      </>
    ) : (
      <>
        The <i>General ledger</i> has been updated and this expense will be
        available to call in the next capital action.
      </>
    );

  return (
    <SuccessPage
      title={`${label} has been added successfully`}
      content={content}
      primaryButton={{
        label: 'Process capital call',
        link: LP_CAPITAL_ACTION_CREATE,
      }}
      tertiaryButton={{
        label: 'Add another income or expense',
        link: createIncomeOrExpenseAddRoute(),
      }}
    />
  );
};

export default Success;
